<template>
  <SSection :desktop-full="true" :title="t('views.cottage.description')">
    <TText tag="div" classes="mb-0">
      <div v-html="item?.description" />
    </TText>
    <template v-if="item.salesService.isShowExternalLinks">
      <UButton
        v-if="item.externalLinks.website"
        :to="routesExternal().normalizeURL(item.externalLinks.website)"
        external
        color="neutral"
        variant="link"
        class="mt-4"
        :aria-label="t('views.cottage.socialLinks.a11y.website')"
        data-test="website"
        >{{ item.externalLinks.website }}</UButton
      >
      <ul class="mt-4 flex gap-x-6">
        <li v-if="item.externalLinks.facebook" data-test="facebook">
          <UButton
            icon="i-bxl-facebook-circle"
            size="md"
            color="neutral"
            variant="subtle"
            square
            :trailing="false"
            :to="routesExternal().normalizeURL(item.externalLinks.facebook)"
            external
            :aria-label="t('views.cottage.socialLinks.a11y.facebook')"
          />
        </li>
        <li v-if="item.externalLinks.instagram" data-test="instagram">
          <UButton
            icon="i-bxl-instagram"
            size="md"
            color="neutral"
            variant="subtle"
            square
            :trailing="false"
            :to="routesExternal().normalizeURL(item.externalLinks.instagram)"
            external
            :aria-label="t('views.cottage.socialLinks.a11y.instagram')"
          />
        </li>
        <li v-if="item.externalLinks.twitter" data-test="twitter">
          <UButton
            icon="i-simple-icons-x"
            size="md"
            color="neutral"
            variant="subtle"
            square
            :trailing="false"
            :to="routesExternal().normalizeURL(item.externalLinks.twitter)"
            external
            :aria-label="t('views.cottage.socialLinks.a11y.x')"
          />
        </li>
      </ul>
    </template>
  </SSection>
</template>

<script setup lang="ts">
import type { CottagePage } from '../../entities/CottagePage'

type itemType = Pick<CottagePage, 'description'> & {
  averagePriceAmount: Pick<CottagePage['averagePriceAmount'], 'amount'>
} & {
  salesService: Pick<CottagePage['salesService'], 'isShowExternalLinks'>
} & {
  externalLinks: Pick<
    CottagePage['externalLinks'],
    'website' | 'facebook' | 'instagram' | 'twitter'
  >
}

interface propsInterface {
  item: itemType
}

defineProps<propsInterface>()
</script>
